import {
  Box,
  Typography as Typo,
  Card as MuiCard,
  styled,
  TypographyProps,
  Skeleton,
} from '@mui/material';

import {DeavtivateComponent} from './innercomponents/Deactivate';
import {EmailAddressComponent} from './innercomponents/ChangeEmail';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const Card = styled(MuiCard)(({theme}) => ({
  borderRadius: theme.spacing(2),
}));

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

const AccountSettingWidget = (props: {loading: boolean}) => {
  const {loading} = props;
  const isLarge = useIsLargeDevice();

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          mx: {xxs: 1.25, md: 0},
          marginLeft: {md: 0.625},
          height: '100%',
          px: {xxs: 1.875, md: 4.625},
          pb: {xxs: 1.875, md: 4.625},
        }}
      >
        <Box>
          {isLarge && (
            <Box
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <Typography
                // component={injectAsChild ? 'p' : 'h1'}
                display="flex"
                fontSize={{xxs: 16, md: 20}}
                fontWeight={400}
                m={0}
                mb={0.5}
                mt={2.75}
                sx={{
                  wordWrap: 'break-word',
                  textTransform: 'capitalize',
                }}
              >
                Account Settings
              </Typography>

              <DeavtivateComponent />
            </Box>
          )}
          <Box mt={isLarge ? 0 : 3}>
            {loading ? (
              <Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  {[
                    ...new Array(5).fill('').map(() => (
                      <>
                        <Skeleton
                          variant="rounded"
                          width={'100%'}
                          height={10}
                          sx={{
                            my: 0.5,
                          }}
                        />
                      </>
                    )),
                  ]}
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
                <Box px={1} mb={4} width={'100%'}>
                  <Skeleton
                    variant="rounded"
                    width={'80%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                      mb: 1,
                    }}
                  />
                  {[
                    ...new Array(5).fill('').map(() => (
                      <>
                        <Skeleton
                          variant="rounded"
                          width={'100%'}
                          height={10}
                          sx={{
                            my: 0.5,
                          }}
                        />
                      </>
                    )),
                  ]}
                  <Skeleton
                    variant="rounded"
                    width={'50%'}
                    height={20}
                    sx={{
                      mt: {xxs: 0, md: 1},
                    }}
                  />
                </Box>
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    marginTop: 1.875,
                    position: 'relative',
                    backgroundColor: 'white',
                  }}
                >
                  <EmailAddressComponent />
                  {!isLarge && <DeavtivateComponent />}
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default AccountSettingWidget;
